import { useAuthStore } from '@/stores/authStore'
import { Navigate } from 'react-router-dom'

export default function HomePage() {
  const isLoading = useAuthStore((s) => s.isLoading)
  const isAdmin = useAuthStore((s) => s.isAdmin)
  const user = useAuthStore((s) => s.user)

  if (isLoading) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-gray-100">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-blue-600 border-t-transparent" />
      </div>
    )
  }

  if (user && isAdmin) {
    return <Navigate to="/admin/monthly-records" replace />
  }

  return (
    <div className="flex flex-col items-center justify-center bg-linear-to-br from-gray-50 to-gray-100 py-16">
      <div className="rounded-lg bg-white px-8 py-10 text-center shadow-lg sm:mx-auto sm:max-w-xl">
        <h1 className="font-bold text-3xl text-gray-800">Sukkamol</h1>
        <p className="mt-4 text-gray-600">
          Sukkamol management system. Manage rooms, contracts, utility records,
          and resident profiles.
        </p>
        <div className="mt-8 flex justify-center">
          <a
            href="/admin/monthly-records"
            className="rounded-lg bg-gray-800 px-6 py-2 font-medium text-white transition-colors hover:bg-gray-700"
          >
            Go to Admin
          </a>
        </div>
      </div>
    </div>
  )
}
